// fetchPopularSearch.js
'use strict';
import {
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
  SET_NETWORKING_FETCHING,
  SET_LIST_ITEMS,
} from '../ActionTypes.js';
import fetch from '../resource/customFetch.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import getNetworkingData from '../selector/getNetworkingData.js';
const selectPath = ['search', 'popular'];
/**
 * Fetch popular search
 * @kind action
 * @return {Promise} Action promise.
 */
const fetchPopularSearch = () => async (dispatch, getState) => {
  const isFetching = getNetworkingData(getState(), selectPath, 'isFetching');
  const isFetched = getNetworkingData(getState(), selectPath, 'isFetched');
  if (isFetched || isFetching) {
    return dispatch({ type: '' });
  }
  const fetchOptions = {
    method: 'GET',
    headers: {
      ...getHeaders(),
    },
  };

  const fetchUrl = getResourceUrl({ endpoint: '/search/hot-keywords' });
  dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });

  try {
    let response = await fetch(fetchUrl.href, fetchOptions);
    if (!response.ok) {
      await handleFetchError({ response });
    }

    const payload = await response.json();
    const itemIds = payload?.data;

    if (itemIds.length) {
      dispatch({
        type: SET_LIST_ITEMS,
        payload: {
          selectPath: ['search', 'popular'],
          itemIds,
        },
      });
    }
    return dispatch({
      type: SET_NETWORKING_SUCCESS,
      payload: { selectPath },
    });
  } catch (error) {
    return dispatch({
      type: SET_NETWORKING_ERROR,
      payload: { selectPath, error },
    });
  }
};

export default fetchPopularSearch;
